import BaseObject from './BaseObject'

class User extends BaseObject {
  static _primaryKey = 'user_id'
  static _apiBaseRoute = 'user'
  static _objectType = 'user'
  static _isExportable = true
  static _propConfigs = [
    {
      property_name: 'user_id'
    },
    {
      property_name: 'firstname'
    },
    {
      property_name: 'lastname'
    },
    {
      property_name: 'displayname',
      validate: 'required'
    },
    {
      property_name: 'title'
    },
    {
      property_name: 'general'
    },
    {
      property_name: 'email',
      validate: 'required'
    },
    {
      property_name: 'email_verified_at',
    },
    {
      property_name: 'auth_provider',
      validate: 'required'
    },
    {
      property_name: 'account',
      relation_class: null,
      relation_class_loader: async function () {
        return await import('./Account')
      },
      relation_type: BaseObject._relationTypes.hasOne,
      validate: 'required'
    },
    {
      property_name: 'user_groups',
      relation_class: null,
      relation_class_loader: async function () {
        return await import('./UserGroup')
      },
      relation_type: BaseObject._relationTypes.hasMany
    }
  ]
  get optionName() {
    return `${this[this._primaryKey]}: ${this.displayname}`
  }
  isEquivalent = item => {
    return (
      this.displayname &&
      item.displayname &&
      this.displayname.toLowerCase() === item.displayname.toLowerCase()
    )
  }
  constructor(row = {}, prefix = '', hasManyPostfix = null) {
    super(row)
    this.prefix = prefix
    this.hasManyPostfix = hasManyPostfix
    if (Object.keys(row).length > 0) {
      this._propConfigs.forEach(propName =>
        this._addPropIfExists(propName, row)
      )
    }
  }
  buildImportableItem = () => {
    const importable = this._clean()
    // make account relation
    importable.account = {
      account_id: this.account.mapped_id
    }
    // make user_groups relation
    if(importable.user_groups) {
      importable.user_groups = importable.user_groups
        .map(userGroup => ({
          user_group_id: userGroup.mapped_id
          // remove any blank test_types that may not have been mapped
        }))
        .filter(userGroup => userGroup.user_group_id != null)
        if (importable.user_groups.length === 0) {
          delete importable.user_groups
        }
    }

    return importable
  }
}

export default User
